import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanTemplateSchema, PlanTemplateTodoSchema } from './shapes';

/** Replaces the product's template (todo order = array order). */
export const putPlanTemplate = defineEndpoint({
  method: 'PATCH',
  path: '/v1/release-products/:productId/plan-template',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({}),
  body: z.object({
    clickupFilterId: z.string().trim().max(100).default(''),
    todos: z.array(PlanTemplateTodoSchema).max(200),
  }),
  response: z.object({ data: PlanTemplateSchema }),
});
